import styles from './ComparisonTable.module.css';

const COLS = ['RepBuddy', 'Apollo', 'Lusha', 'ZoomInfo'];

// cells order: [RepBuddy, Apollo, Lusha, ZoomInfo]
// sourcedCol marks a cell that is a characterization from public reviews (see footnote).
const ROWS = [
  { label: 'Entry price', cells: ['$49/mo', '$49/mo', '$22/mo', '~$15,000/yr'] },
  {
    label: 'What a credit buys',
    cells: [
      'A verified, employment-checked lead',
      'Any action (emails, phones, exports all nibble credits)',
      'A contact reveal',
      'Enterprise contract',
    ],
  },
  {
    label: 'Email verification',
    cells: ['Included, every lead + bulk lists', 'Extra credits / your problem', 'Limited', 'Included'],
  },
  { label: '“Still works there” check', cells: ['Every lead', 'No', 'No', 'Periodic refresh'] },
  {
    label: 'Junk-company filtering (staffing / agency / VC)',
    cells: ['Automatic', 'Manual filters', 'Manual', 'Manual'],
  },
  {
    label: 'Workflow',
    cells: ['One chat agent runs the whole hunt', 'You drive the UI', 'Chrome extension', 'Platform + training'],
  },
  {
    label: 'Surprise overage bills',
    cells: ['Never: quotes before every run', 'The #1 user complaint', 'Credit confusion', 'Annual lock-in'],
    sourcedCol: 1,
  },
  { label: 'Free trial', cells: ['7 days, no card', 'Free tier', 'Free tier', 'None'] },
];

export default function ComparisonTable() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.scroll}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.corner} scope="col"><span className={styles.srOnly}>Feature</span></th>
                {COLS.map((c) => (
                  <th
                    key={c}
                    scope="col"
                    className={`${styles.colHead} ${c === 'RepBuddy' ? styles.repHead : ''}`}
                  >
                    {c}
                    {c === 'RepBuddy' && <span className={styles.usTag}>us</span>}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.label}>
                  <th scope="row" className={styles.rowLabel}>{row.label}</th>
                  {row.cells.map((cell, i) => (
                    <td key={i} className={`${styles.cell} ${i === 0 ? styles.repCell : ''}`}>
                      {cell}
                      {row.sourcedCol === i && <sup className={styles.sup}>*</sup>}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className={styles.footnote}>
          <span className={styles.sup}>*</span> Characterization based on public reviews
          (G2, Reddit), not our own assertion.
        </p>
      </div>
    </section>
  );
}
